export default "__VITE_ASSET__BGmWoIdY__"